<template>
  <div id="jci-program-report" class="page-container">
    <!-- Stunning Header Card -->
    <v-card elevation="20" class="header-card mb-4 overflow-hidden">
      <div class="header-gradient">
        <div class="header-content pa-6">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <div class="header-icon-box mr-4">
                  <v-icon size="48" color="white">mdi-file-chart</v-icon>
                </div>
                <div>
                  <h1
                    class="header-title text-white text-h3 font-weight-bold mb-2"
                  >
                    {{ PageTitle }}
                  </h1>
                  <p class="header-subtitle text-white">
                    Program Management & Reporting System
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <div class="d-flex justify-end flex-wrap gap-2">
                <!-- Refresh Button -->
                <v-btn
                  @click.prevent="refreshPageData"
                  color="rgba(255,255,255,0.2)"
                  elevation="0"
                  rounded
                  height="45"
                  min-width="150"
                  class="action-btn white--text"
                >
                  <v-icon left size="22">mdi-refresh</v-icon>
                  REFRESH
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- Modernized Floating Action Button -->
    <v-container class="py-0">
      <v-speed-dial
        v-if="FloatingButtonFlag"
        v-model="fab"
        :top="top"
        :bottom="bottom"
        :right="right"
        :left="left"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
        :fixed="true"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="#667eea"
            dark
            fab
            elevation="12"
            class="modern-fab"
          >
            <v-icon v-if="fab" size="28">mdi-close</v-icon>
            <v-icon v-else size="28">mdi-plus-circle</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          dark
          small
          color="#667eea"
          @click.prevent="addRecordPrompt = true"
          elevation="8"
        >
          <v-icon>mdi-file-plus</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-container>
    <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
      <add-event-online-payment
        pageDescription="Add Event Online Payment"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt"
        v-if="addRecordPrompt"
      ></add-event-online-payment>
    </v-dialog>

    <!-- Filter Card -->
    <v-card elevation="12" class="filter-card mb-4">
      <v-card-text class="pa-6">
        <!-- Loading State -->
        <div v-if="LoadingFlag" class="text-center py-8">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <p class="mt-4 text-h6 primary--text">Loading program data...</p>
        </div>

        <v-form
          ref="form2"
          v-model="valid1"
          lazy-validation
          v-if="!LoadingFlag"
        >
          <!-- Filter Header -->
          <div class="filter-header mb-6">
            <v-icon color="#667eea" size="32" class="mr-3"
              >mdi-filter-variant</v-icon
            >
            <span class="text-h5 font-weight-bold primary--text"
              >Search & Filter Programs</span
            >
          </div>

          <v-row>
            <v-col cols="12" sm="6" lg="3" md="6">
              <div class="filter-field">
                <v-icon small color="#667eea" class="mr-2"
                  >mdi-calendar-month</v-icon
                >
                <label class="field-label">Event Type</label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="EventTypeOptionsLoading"
                  :items="EventTypeOptions"
                  :rules="EventTypeRules"
                  v-model="EventType"
                  hint="Select event type"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-format-list-bulleted"
                ></v-autocomplete>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <div class="filter-field">
                <v-icon small color="#667eea" class="mr-2"
                  >mdi-map-marker</v-icon
                >
                <label class="field-label">Zone</label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  hint="Select a zone"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-map"
                ></v-autocomplete>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <div class="filter-field">
                <v-icon small color="#667eea" class="mr-2"
                  >mdi-calendar-start</v-icon
                >
                <label class="field-label">From Date</label>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="FromDate"
                      label="From Date"
                      hint="Select from date"
                      persistent-hint
                      readonly
                      v-on="on"
                      class="custom-input"
                      outlined
                      dense
                      prepend-inner-icon="mdi-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="FromDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <div class="filter-field">
                <v-icon small color="#667eea" class="mr-2"
                  >mdi-calendar-end</v-icon
                >
                <label class="field-label">To Date</label>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="ToDate"
                      label="To Date"
                      hint="Select to date"
                      persistent-hint
                      readonly
                      v-on="on"
                      class="custom-input"
                      outlined
                      dense
                      prepend-inner-icon="mdi-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ToDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>

          <v-row wrap class="mt-6">
            <v-col align="center" cols="12" md="12">
              <v-btn
                :disabled="!valid1"
                @click.prevent="searchForm"
                :loading="SearchFlag"
                color="#667eea"
                elevation="8"
                x-large
                rounded
                class="search-btn white--text"
              >
                <v-icon left size="24">mdi-magnify</v-icon>
                SEARCH PROGRAMS
              </v-btn>
              <v-btn
                v-if="OnlinePaymentButtonFlag"
                @click.prevent="addRecordPrompt = true"
                color="#667eea"
                elevation="8"
                x-large
                rounded
                class="search-btn white--text ml-4"
              >
                <v-icon left size="24">mdi-plus</v-icon>
                ADD PAYMENT
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <!-- Dialogs -->
    <v-dialog v-model="dialog" scrollable max-width="500px">
      <v-card class="modern-dialog-card elevation-24">
        <!-- Professional Header -->
        <div class="dialog-header-gradient">
          <div class="dialog-header-content">
            <v-row align="center" justify="space-between">
              <v-col cols="auto">
                <div class="d-flex align-center">
                  <div class="dialog-header-icon mr-3">
                    <v-icon size="32" color="white"
                      >mdi-information-outline</v-icon
                    >
                  </div>
                  <h2 class="dialog-header-title white--text">
                    {{ dialogTitle }}
                  </h2>
                </div>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  icon
                  dark
                  small
                  @click="dialog = false"
                  class="dialog-close-btn"
                  v-tooltip.left="'Close'"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content-text pa-6">
          <p class="dialog-message">{{ dialogContent }}</p>
        </v-card-text>

        <!-- Action Footer -->
        <v-divider class="dialog-divider"></v-divider>
        <v-card-actions class="dialog-footer pa-4">
          <v-spacer />
          <v-btn
            @click="dialog = false"
            color="#667eea"
            elevation="4"
            rounded
            height="40"
            min-width="120"
            class="dialog-close-button white--text"
          >
            <v-icon left small>mdi-check-circle</v-icon>
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="previewPlansFlag"
      v-if="previewPlansFlag"
      persistent
      max-width="75%"
    >
      <jci-program-plans-list-dialog
        v-if="previewPlansFlag"
        :record="selectedData"
        @hideDialog="hidePlansPreview($event)"
      ></jci-program-plans-list-dialog>
    </v-dialog>

    <!-- Stats Card -->
    <v-card elevation="8" class="stats-card mb-4" v-if="tableData1.length > 0">
      <v-card-text class="pa-4">
        <v-row align="center">
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <div class="stats-icon-box mr-3">
                <v-icon size="40" color="white">mdi-database</v-icon>
              </div>
              <div>
                <p class="stats-label white--text mb-0">Total Programs</p>
                <h2 class="stats-number white--text">
                  {{ tableData1.length }}
                </h2>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-btn
              v-if="
                tableData1.length > 0 &&
                tableOptions1.DownloadButtonFlag == true
              "
              @click.prevent="
                generateExcel(
                  tableData1,
                  tableOptions1.ExcelFields,
                  tableOptions1.ExcelFileName,
                  'My Worksheet'
                )
              "
              color="#20B2AA"
              elevation="8"
              large
              rounded
              class="export-btn white--text"
            >
              <v-icon left>mdi-file-excel</v-icon>
              EXPORT TO EXCEL
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Search Bar -->
    <v-card elevation="8" class="search-card mb-4" v-if="tableData1.length > 0">
      <v-card-text class="pa-4">
        <v-text-field
          v-model="search"
          placeholder="🔍 Search by any field..."
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          class="search-input"
        >
          <template v-slot:append>
            <v-chip v-if="search" color="success" small>
              {{ search }}
            </v-chip>
          </template>
        </v-text-field>
      </v-card-text>
    </v-card>

    <!-- Data Table Card -->
    <v-card elevation="12" class="table-card" v-if="tableData1.length > 0">
      <v-data-table
        class="stunning-table"
        loading-text="Loading... Please wait"
        v-model="selected"
        :search="search"
        :loading="TableLoadingFlag"
        :item-key="tableOptions1.ItemKey"
        :single-select="tableOptions1.SingleSelectFlag"
        :headers="tableColumns1"
        :items="tableData1"
        :items-per-page="tableOptions1.ItemsPerPage"
        :footer-props="tableOptions1.FooterProps"
      >
        <template v-slot:[`item.ActiveStatusTxt`]="{ item }">
          <v-chip
            :color="getActiveStatusColor(item.ActiveStatusTxt)"
            draggable
            dark
            class="status-chip"
          >
            <v-icon small left>mdi-circle-medium</v-icon>
            {{ item.ActiveStatusTxt }}
          </v-chip>
        </template>
        <template v-slot:[`item.StatusTxt`]="{ item }">
          <v-chip
            :color="getActiveStatusColor(item.StatusTxt)"
            draggable
            dark
            class="status-chip"
          >
            <v-icon small left>mdi-circle-medium</v-icon>
            {{ item.StatusTxt }}
          </v-chip>
        </template>
        <template v-slot:[`item.ProfilePic`]="{ item }">
          <v-avatar size="60" class="program-avatar">
            <img :src="item.ProfilePic" alt="Program" />
          </v-avatar>
        </template>
        <template v-slot:[`item.VisibilityZoneTxt`]="{ item }">
          <v-btn
            class="mx-2"
            icon
            dark
            small
            color="primary"
            @click="openDialog(item, 2)"
          >
            <v-icon dark> mdi-eye </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.VisibilityDesignationTxt`]="{ item }">
          <v-btn
            class="mx-2"
            icon
            dark
            small
            color="primary"
            @click="openDialog(item, 1)"
          >
            <v-icon dark> mdi-eye </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <!-- Preview Button -->
          <v-tooltip bottom v-if="item.PreviewFlag == true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                icon
                size="24px"
                color="blue"
                @click="previewData(item, $event)"
                v-bind="attrs"
                v-on="on"
                class="action-icon-btn"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span> Preview </span>
          </v-tooltip>
          <!-- Plans Button -->
          <v-tooltip bottom v-if="item.PlansFlag == true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                icon
                size="24px"
                color="blue"
                @click="plansData(item, $event)"
                v-bind="attrs"
                v-on="on"
                class="action-icon-btn"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span> Plans </span>
          </v-tooltip>
          <!-- Edit Button -->
          <v-tooltip bottom v-if="item.EditFlag">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                icon
                size="24px"
                color="primary"
                @click="editData(item, $event)"
                v-bind="attrs"
                v-on="on"
                class="action-icon-btn"
              >
                mdi-file-document-edit
              </v-icon>
            </template>
            <span> Edit </span>
          </v-tooltip>
          <!-- Delete Button -->
          <v-tooltip bottom v-if="item.DeleteFlag">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                icon
                size="24px"
                color="red"
                @click="deleteConfirmAlert(item, $event)"
                v-bind="attrs"
                v-on="on"
                class="action-icon-btn"
              >
                mdi-delete
              </v-icon>
            </template>
            <span> Delete </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Empty State Card -->
    <v-card
      class="empty-state-card"
      v-if="ResultFlag && tableData1.length == 0"
      elevation="0"
    >
      <v-card-text class="text-center pa-10">
        <v-icon size="80" color="#ccc" class="mb-4">mdi-database-search</v-icon>
        <h3 class="text-h6 text-grey-1 mb-2">No records found</h3>
        <p class="text-grey-4 mb-4">
          Try adjusting your search or filter criteria
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import AddEventOnlinePayment from "@/view/pages/erp/events/natcon/AddEventOnlinePayment.vue";
import JciProgramPlansListDialog from "@/view/pages/erp/jci-program/JciProgramPlansListDialog.vue";

export default {
  mixins: [common],
  components: {
    AddEventOnlinePayment,
    JciProgramPlansListDialog,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      TableLoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      dialog: false,
      dialogTitle: "",
      dialogContent: "",

      selectedData: {},
      previewPlansFlag: false,

      rows: [],
      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OnlinePaymentButtonFlag: false,
      ReceiptFlag: false,
      ApplicationFlag: false,
      MemberImageFlag: false,

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      EventTypeRules: [],
      EventType: "",
      EventTypeOptions: [],
      EventTypeOptionsLoading: false,

      PaymentId: "",
      PaymentIdRules: [],

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LO" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
      RoleId: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var CurrentYearId = this.$session.get("CurrentYearId");
        CurrentYearId = 1;
        CurrentYearId =
          CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
        this.CurrentYearId = CurrentYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        // RoleId = 4;
        this.RoleId = RoleId;

        var todayDate = new Date().toISOString().slice(0, 10);
        console.log(todayDate);

        this.FromDate = todayDate;
        this.ToDate = todayDate;

        this.getZoneCodeOptions();
        this.getEventTypeOptions();
      }
    },
    EventTypeOptions: function () {
      console.log("watch EventTypeOptions");
      this.EventTypeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
    },
    openDialog(tr, id) {
      console.log("openDialog called");
      console.log({ id });
      console.log({ tr });
      var dialog = false;
      var dialogTitle="";
      var dialogContent = "";
      switch (id) {
        case 1:
          dialog = true;
          dialogTitle="Visible Designation";
          dialogContent = tr.VisibilityDesignationTxt;
          break;

        case 2:
          dialog = true;
          dialogTitle="Visible Zone";
          dialogContent = tr.VisibilityZoneTxt;
          break;

        default:
          break;
      }
      this.dialogTitle = dialogTitle;
      this.dialogContent = dialogContent;
      this.dialog = dialog;
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var url = "/jci-event/edit";
        var id = tr.ProgramId;
        console.log({ id });
        var params = {
          v2: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one event to edit";
        this.toast("error", message);
      }
    },
    previewData(tr) {
      console.log("previewData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var url = "/members/subscription/assign";
        var id = tr.LomPaymentId;
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one LO to preview";
        this.toast("error", message);
      }
    },
    hidePlansPreview(flag) {
      console.log("hidePlansPreview called");
      console.log({ flag });
      this.selectedData = {};
      this.previewPlansFlag = false;
    },
    plansData(tr) {
      console.log("plansData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.previewPlansFlag = true;
      } else {
        var message = "Kindly select one event";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.resetForm();
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_events",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getEventTypeOptions() {
      console.log("getEventTypeOptions called");
      this.EventType = "";
      this.EventTypeOptionsLoading = true;
      var selectbox1_source = "EventType";
      var selectbox1_destination = "EventTypeOptions";
      var selectbox1_url = "api/jci-program-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getYearCodeOptions(source, destination) {
      console.log("getYearCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      // var CurrentYearId = this.CurrentYearId;
      var CurrentYearId = 1;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/jci-year/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();
      var FromDate = this.FromDate;
      var ToDate = this.ToDate;
      console.log(
        "validate1=" +
          validate1 +
          ", FromDate=" +
          FromDate +
          ", ToDate=" +
          ToDate
      );

      if (validate1 && FromDate != "" && ToDate != "") {
        this.SearchFlag = true;
        this.tableData1 = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/lists";
        var upload = {
          UserInterface: 1,
          EventType: this.EventType,
          Zone: this.ZoneCode,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            thisIns.tableColumns1 = records.TableHeader;
            thisIns.tableOptions1 = records.TableOptions;

            if (flag == 1) {
              thisIns.tableData1 = records.TableData;
              thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (FromDate == "") {
          message += "From Date should not be empty. ";
        }
        if (ToDate == "") {
          message += "To Date should not be empty. ";
        }
        // this.toast("error", message);
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* ============================================
   HEADER CARD
   ============================================ */
.header-card {
  border-radius: 20px !important;
  overflow: hidden;
  animation: slideDown 0.6s ease-out;
}

.header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: float 3s ease-in-out infinite;
}

.header-title {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 0.8s ease-out;
}

.header-subtitle {
  opacity: 0.95;
  animation: fadeInUp 1s ease-out;
}

.action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 700;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
  }
}

/* ============================================
   FILTER CARD
   ============================================ */
.filter-card {
  border-radius: 16px !important;
  animation: fadeIn 0.8s ease-out;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.1) !important;
}

.filter-header {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 3px solid #667eea;
  margin-bottom: 24px;
}

.filter-field {
  margin-bottom: 12px;
  animation: fadeIn 0.6s ease 0.1s both;

  .field-label {
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.custom-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    background: rgba(102, 126, 234, 0.04) !important;
    border: 2px solid rgba(102, 126, 234, 0.1) !important;
    transition: all 0.3s ease;

    &:hover {
      border-color: rgba(102, 126, 234, 0.3) !important;
      background: rgba(102, 126, 234, 0.08) !important;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  &:focus-within ::v-deep .v-input__slot {
    border-color: #667eea !important;
    background: rgba(102, 126, 234, 0.12) !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
  }
}

.search-btn {
  font-weight: 700;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  text-transform: uppercase;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4) !important;
  }
}

/* ============================================
   STATS CARD
   ============================================ */
.stats-card {
  border-radius: 16px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  animation: slideInLeft 0.8s ease-out;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2) !important;
}

.stats-icon-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.stats-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.9;
}

.stats-number {
  font-size: 2.5rem;
  font-weight: 800;
  letter-spacing: 1px;
}

.export-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  text-transform: uppercase;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(32, 178, 170, 0.4) !important;
  }
}

/* ============================================
   SEARCH CARD
   ============================================ */
.search-card {
  border-radius: 16px !important;
  animation: fadeIn 1s ease-out;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.1) !important;
}

.search-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    background: rgba(255, 255, 255, 0.9) !important;
    transition: all 0.3s ease;

    &:hover {
      border-color: #667eea !important;
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
    }
  }

  &:focus-within ::v-deep .v-input__slot {
    border-color: #667eea !important;
    background: white !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
  }
}

/* ============================================
   TABLE CARD
   ============================================ */
.table-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: fadeInUp 1s ease-out;
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.15) !important;
}

.stunning-table {
  ::v-deep {
    .v-data-table__wrapper {
      overflow-x: auto;

      table {
        border-collapse: collapse;

        thead {
          tr {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

            th {
              background: transparent !important;
              color: white !important;
              font-weight: 700 !important;
              font-size: 14px !important;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              padding: 20px 16px !important;
              border: none !important;
            }
          }
        }

        tbody tr {
          transition: all 0.3s ease;
          border-bottom: 1px solid rgba(102, 126, 234, 0.1) !important;

          &:hover {
            background: linear-gradient(
              90deg,
              rgba(102, 126, 234, 0.05) 0%,
              rgba(118, 75, 162, 0.05) 100%
            ) !important;
            transform: scale(1.01);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          td {
            padding: 16px !important;
            color: #333;
            font-size: 14px;
          }
        }
      }
    }
  }
}

.status-chip {
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }
}

.program-avatar {
  border: 3px solid #667eea;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
}

.action-icon-btn {
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.2) rotate(10deg);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
}

/* ============================================
   EMPTY STATE
   ============================================ */
.empty-state-card {
  border-radius: 16px !important;
  border: 2px dashed rgba(102, 126, 234, 0.2) !important;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.02) 0%,
    rgba(118, 75, 162, 0.02) 100%
  ) !important;
  animation: slideInUp 0.6s ease-out;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.08) !important;

  .v-card__text {
    padding: 60px 20px !important;

    .v-icon {
      animation: float 4s ease-in-out infinite;
      margin-bottom: 16px;
    }

    h3 {
      color: #667eea;
      font-weight: 700;
      margin-bottom: 8px;
    }

    p {
      color: #999;
      font-size: 14px;
    }
  }
}

/* ============================================
   ANIMATIONS
   ============================================ */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 960px) {
  .header-content {
    text-align: center;

    .d-flex {
      flex-direction: column;
      align-items: center !important;
    }

    .text-right {
      text-align: center !important;
    }
  }

  .action-btn {
    margin: 4px 0 !important;
  }

  .header-title {
    font-size: 1.8rem !important;
  }

  .header-subtitle {
    font-size: 0.9rem;
  }

  .search-btn {
    width: 100% !important;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 600px) {
  .page-container {
    padding: 12px;
  }

  .header-content {
    padding: 16px !important;
  }

  .header-icon-box {
    padding: 10px !important;
  }

  .header-title {
    font-size: 1.4rem !important;
  }

  .header-subtitle {
    font-size: 0.85rem;
  }

  .filter-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .search-btn {
    width: 100% !important;
    margin-bottom: 8px !important;
  }

  .stats-icon-box {
    width: 50px !important;
    height: 50px !important;

    .v-icon {
      font-size: 28px !important;
    }
  }

  .stats-number {
    font-size: 1.8rem !important;
  }

  .custom-input {
    ::v-deep .v-input__slot {
      border-radius: 8px !important;
    }
  }
}

/* ============================================
   SCROLLBAR STYLING
   ============================================ */
::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep ::-webkit-scrollbar-track {
  background: rgba(102, 126, 234, 0.05);
  border-radius: 10px;
}

::v-deep ::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.3);
  border-radius: 10px;

  &:hover {
    background: rgba(102, 126, 234, 0.5);
  }
}

/* ============================================
   ADDITIONAL STYLING
   ============================================ */
::v-deep .v-card {
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.08) !important;
}

::v-deep .gap-2 {
  gap: 8px;
}

::v-deep .primary--text {
  color: #667eea !important;
}

::v-deep .white--text {
  color: white !important;
}

/* ============================================
   MODERN DIALOG STYLING
   ============================================ */
.modern-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: dialogSlideIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.25) !important;
}

.dialog-header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }
}

.dialog-header-content {
  position: relative;
  z-index: 1;
}

.dialog-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 2s ease-in-out infinite;
}

.dialog-header-title {
  font-size: 1.2rem;
  font-weight: 800;
  margin: 0;
  letter-spacing: 0.5px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dialog-close-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

  &:hover {
    transform: scale(1.15) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }

  &:active {
    transform: scale(0.95) !important;
  }
}

.dialog-content-text {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog-message {
    font-size: 15px;
    color: #333;
    font-weight: 500;
    line-height: 1.8;
    margin: 0;
    text-align: center;
    letter-spacing: 0.2px;
    animation: fadeIn 0.6s ease-out 0.2s both;
  }
}

.dialog-divider {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(102, 126, 234, 0.2),
    transparent
  ) !important;
}

.dialog-footer {
  background: linear-gradient(90deg, #f9fafb 0%, #ffffff 100%);
}

.dialog-close-button {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25) !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  }

  &:active {
    transform: translateY(0);
  }
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>